import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function ProductReveal() {
  const scrollToCompra = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy-dark py-16 md:py-24 px-4 relative" data-id="element-115">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-30" data-id="element-116"></div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-118">
          <p className="text-gold font-bold text-xl mb-4 uppercase tracking-widest" data-id="element-119">
            Acá es donde todo cambia
          </p>
          <p className="text-2xl text-gray-300 mb-8" data-id="element-120">Presentamos:</p>

          <h2 className="text-5xl md:text-7xl font-black text-white mb-10 drop-shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-121">
            Estudio Jurídico <span className="text-gold" data-id="element-122">Listo</span>
          </h2>

          <div className="mb-12 cursor-pointer relative group inline-block" onClick={scrollToCompra} data-id="element-123">
            <div className="absolute inset-0 bg-gold/20 blur-2xl rounded-full group-hover:bg-gold/30 transition-all duration-300" data-id="element-124"></div>
            <img src="https://cdn.magicpatterns.com/uploads/fy79wuSYUogRN224kaC9Zw/MOCKUP_PNG.png" alt="Estudio Jurídico Listo" className="w-full max-w-xl mx-auto relative z-10 drop-shadow-2xl group-hover:scale-105 transition-transform duration-500" data-id="element-125" />
          </div>

          <div className="max-w-3xl mx-auto text-lg md:text-xl text-gray-300 space-y-6 mb-12" data-id="element-126">
            <p data-id="element-127">
              Un sistema completo para transformar tu estudio en una máquina
              organizada, clara y rentable.
            </p>
            <p data-id="element-128">Sin vueltas. Sin teoría. Sin herramientas complejas.</p>
            <p className="text-2xl font-bold text-gold" data-id="element-129">
              👉 Solo estructura que funciona.
            </p>
          </div>

          <div className="bg-navy-light p-8 md:p-12 rounded-2xl border border-gold/20 mb-12 text-left" data-id="element-130">
            <h3 className="text-3xl font-bold text-white mb-8 text-center" data-id="element-131">
              ¿Qué incluye?
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-132">
              <div className="flex items-start gap-3" data-id="element-133">
                <span className="text-gold text-xl mt-1" data-id="element-134">✔</span>
                <span className="text-white font-medium text-lg" data-id="element-135">
                  Plantillas listas para usar
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-136">
                <span className="text-gold text-xl mt-1" data-id="element-137">✔</span>
                <span className="text-white font-medium text-lg" data-id="element-138">
                  Sistema de seguimiento de clientes
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-139">
                <span className="text-gold text-xl mt-1" data-id="element-140">✔</span>
                <span className="text-white font-medium text-lg" data-id="element-141">
                  Organización clara de casos
                </span>
              </div>
              <div className="flex items-start gap-3" data-id="element-142">
                <span className="text-gold text-xl mt-1" data-id="element-143">✔</span>
                <span className="text-white font-medium text-lg" data-id="element-144">
                  Estructura profesional del estudio
                </span>
              </div>
            </div>

            <div className="mt-10 text-center space-y-4 text-gray-300" data-id="element-145">
              <p data-id="element-146">Todo diseñado para que lo implementes rápido.</p>
              <p className="font-bold text-white" data-id="element-147">
                Sin perder horas aprendiendo.
              </p>
            </div>
          </div>

          <CTAButton data-id="element-148" />
        </motion.div>
      </div>
    </section>;
}